import React, { Component, createRef } from "react";
// import { sanitize } from 'dompurify';
import DOMPurify from "dompurify";
const sanitize = DOMPurify.sanitize;

class NoteBookUser extends Component {
    constructor(props) {
        super(props);
        this.messagesEndRef = createRef()
        this.state = {
            isShowMore: false,
        }
    }
    snippetLongString = (snippet) => {
        if (snippet?.length > 150) {
            let text = "";
            let spanIndex = snippet.indexOf('<span class=');
            if (spanIndex !== -1) {
                text = snippet.substring(spanIndex, (spanIndex + 150))//cuts to spanIndex+150
                let last = text.lastIndexOf(" ")//gets last space (to avoid cutting the middle of a word)
                text = text.substring(0, last)//cuts from last space (to avoid cutting the middle of a word)
            } else {
                text = snippet.substring(0, 150)//cuts to 70
                let last = text.lastIndexOf(" ")//gets last space (to avoid cutting the middle of a word)
                text = text.substring(0, last)//cuts from last space (to avoid cutting the middle of a word)
            }
            //text = text + ` ...`//adds (...) at the end to show that it's cut
            return text
        }
        return snippet;
    }
    handleOnClickSourceTextExpand = (text) =>{
        this.props.handleOnClickSourceTextExpand(this.props.conversationIndex,
            this.props.conversation,text,this.props.conversation.eventid)
    }
    handleRefreshAns = () =>{
        let commandType = (this.props.conversation._commandType) ? this.props.conversation._commandType : this.props.conversation.commandType
        this.props.handleRefreshQuery(commandType,
            [this.props.conversation.message],
            this.props.conversationIndex,
            this.props.conversation.eventid
        )
    }
    render() {
        let { isShowMore } = this.state;
        let { conversation } = this.props;
        let text = "";
        if (!isShowMore) {
            text = this.snippetLongString(conversation.message);
        }
        else {
            text = conversation.message;
        }
        return (<div className="note-book-message-outer" >
            <div className="note-book-message-body">
                <div className="note-book-message-inner-body">
                    <div className="note-bookmessage-text">
                        <div dangerouslySetInnerHTML={{ __html: sanitize(text) }} />
                    </div>
                </div>
                <div className="note-book-footer-conc">
                    <span title="Refresh" className="span-button" onClick={this.handleRefreshAns}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M14.6662 6.66667C14.6662 6.66667 13.3296 4.84548 12.2437 3.75883C11.1579 2.67218 9.65733 2 7.99979 2C4.6862 2 2 4.68629 2 8C2 11.3137 4.6862 14 7.99979 14C10.7351 14 13.0429 12.1695 13.7651 9.66667M14.6662 6.66667V2.66667M14.6662 6.66667H10.6664" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    </span>
                    <span className="span-button" title='Rewrite' onClick={()=>this.handleOnClickSourceTextExpand(conversation.message)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <g clip-path="url(#clip0_991_3522)">
                                <path d="M1.91719 12.0771C1.94782 11.8014 1.96313 11.6636 2.00483 11.5348C2.04183 11.4205 2.09411 11.3117 2.16024 11.2114C2.23479 11.0984 2.33284 11.0003 2.52896 10.8042L11.3328 2.00001C12.0692 1.26363 13.2631 1.26363 13.9994 2.00001C14.7358 2.73639 14.7358 3.9303 13.9994 4.66668L5.19553 13.4709C4.99942 13.667 4.90136 13.765 4.78832 13.8396C4.68803 13.9057 4.57926 13.958 4.46497 13.995C4.33615 14.0367 4.19832 14.052 3.92267 14.0826L1.6665 14.3333L1.91719 12.0771Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_991_3522">
                                    <rect width="15.9994" height="16" rx="4" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </span>

                </div>
            </div>
            <br />
        </div>)
    }

}
export default NoteBookUser;